/**
 *
 * Custom function
 *
 */

(function ($) {

    /*
     *	Funzione per rendere un box tutto cliccabile. ATTENZIONE: all'interno del box deve esserci un unico link
     */

    function allClick() {
        var clickbox = $('.allclick');
        clickbox.each(function () {
            var $this = $(this);
            $this.css('cursor', 'pointer');
            $this.find('a').click(function (event) {
                event.preventDefault();
            });

            if ($this.find('a').attr('target') == '_blank') {
                $this.click(function () {
                    window.open($('a', this).attr('href'));
                });
            } else {
                $this.click(function () {
                    window.location.href = $('a', this).attr('href');
                });
            }
        });
    }

    /*
     *	Caricamento ajax delle immagini dal marcatore [data-loadimg] e dei background dal marcatore [data-loadbackground]
     */

    function loadAsynchronousImage() {

        $('*[data-loadimg]').each(function () {
            var box = $(this),
                src = box.attr('data-loadimg'),
                alt = '',
                img = new Image();

            if (box.attr('data-alt')) {
                alt = box.attr('data-alt');
            }

            $(img).load(function () {
                box.append('<img src="' + src + '" alt="' + alt + '" width="' + img.width + '" height="' + img.height + '">');
                $('img', box).hide().fadeIn();

            }).attr('src', src);
        });

        $('*[data-loadbackground]').each(function () {
            var box = $(this),
                src = box.attr('data-loadbackground');

            box.css({
                'background-image': 'url(' + src + ')',
                'background-repeat': 'no-repeat',
                'background-position': 'top center'
            });

            if (box.has(['data-position'])) {
                box.css({
                    'background-position': box.attr('data-position'),
                    'background-image': 'url(' + src + ')',
                    'background-repeat': 'no-repeat'
                });
            } else {
                box.css({
                    'background-position': 'top center',
                    'background-image': 'url(' + src + ')',
                    'background-repeat': 'no-repeat'
                });
            }

            if (box.attr('data-repeat') == 'repeat') {
                box.css({
                    'background-repeat': 'repeat'
                });
            } else {
                box.css({
                    'background-repeat': 'no-repeat'
                });
            }
        });
    }


    /*
     *	Funzione per la gestione dei bottoni "condividi" legati ai social
     */

    function socialOpen() {
        $('[data-socialurl]').each(function () {
            var $this = $(this),
                url = $this.attr('data-socialurl');

            $this.click(function () {
                window.open(url, '', 'width=500, height=500');
            });

        });
    }

    function trackAdwordsCampaign() {
        //$('body').append('<img height="1" width="1" style="border-style:none;" alt="" src=""/>');
    }


    /*
     *	Funzione per l'apertura di una finestra modale tramite cookie
     */

    function openModal() {
        if ($('#onloadmodal').length) {
            if (!$.cookie("openmodal")) {
                $('#onloadmodal').modal();
                $.cookie("openmodal", 'no', {
                    path: '/'
                });
            }
        }
    }



    /*
     *	Funzione per l'apertura di un iframe all'interno di una finestra modale
     */

    function iframeModalOpen() {
        $('.videoModal').each(function () {
            // impostiamo gli attributi da aggiungere all'iframe es: data-src andrà ad impostare l'url dell'iframe
            $('.modalButton').on('click', function (e) {
                var src = $(this).attr('data-src');
                var width = $(this).attr('data-width') || 640; // larghezza dell'iframe se non impostato usa 640
                var height = $(this).attr('data-height') || 360; // altezza dell'iframe se non impostato usa 360

                var allowfullscreen = $(this).attr('data-video-fullscreen'); // impostiamo sul bottone l'attributo allowfullscreen se è un video per permettere di passare alla modalità tutto schermo

                // stampiamo i nostri dati nell'iframe
                $(".videoModal iframe").attr({
                    'src': src,
                    'height': height,
                    'width': width,
                    'allowfullscreen': ''
                });
            });

            // se si chiude la modale resettiamo i dati dell'iframe per impedire ad un video di continuare a riprodursi anche quando la modale è chiusa
            $(this).on('hidden.bs.modal', function () {
                $(this).find('iframe').html("");
                $(this).find('iframe').attr("src", "");
            });
        });
    }

    /*
     *	Funzione per la formattazione delle tabelle con classe listino
     *	tramite le classi di bootstrap
     */

    function responsiveTable() {

        $('.entry-content table').each(function () {
            var $this = $(this);
            $this.addClass('table');
            $this.wrap('<div class="table-responsive"></div>');
        });

        if ($(window).width() <= 767) {

            $('#primary .table-responsive').prepend(
                '<span class="angle-scroll-left">' +
                '<i class="icon icon-edt-arrow-right-6 angle-scroll-left__animation"></i>' +
                '</span>'
            );

            $('#primary .table-responsive').on('scroll', function (event) {
                var angleScrollLeft = $('.angle-scroll-left');

                if ($(this).scrollLeft() >= 1) {
                    angleScrollLeft.addClass('fade-out');
                } else {
                    angleScrollLeft.removeClass('fade-out');
                }
            });

            $('#primary').find('.table-responsive').each(function () {
                var table = $(this);
                $('.angle-scroll-left').click(function (event) {
                    table.animate({
                        scrollLeft: '+=60'
                    }, 200);
                });
            });
        }
    }

    /*
     *	Funzione per l'inizializzazione della mappa
     */
    function initializeGmap() {
        $('*[data-location]').each(function () {
            var map = $(this),
                address = map.attr('data-location');
            map.setGMap({
                address: address
            });
        });
    }


    function initializeMap() {

        var locations = new Array();
        var arrayMarker = new Array();
        var infoWindow = new google.maps.InfoWindow();

        var directionsService = new google.maps.DirectionsService();
        var directionsDisplay = new google.maps.DirectionsRenderer();


        //Instazio la mappa centrandola con le coordinate della prima localitò
        var map = new google.maps.Map(document.getElementById('map_canvas'), {
            center: new google.maps.LatLng($(".locations-list li:first-child a").data("location-lat"), $(".locations-list li:first-child a").data("location-lon")),
            zoom: 12,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });

        //Ciclo il menù con i punti di interesse per leggere gli attributi data dalla DOM
        $(".locations-list li").each(function () {

            var name = ($('a', this).data("location-name"));
            var img = ($('a', this).data("location-image"));
            var lat = ($('a', this).data("location-lat"));
            var lon = ($('a', this).data("location-lon"));
            var index = ($('a', this).data("location-index"));

            //Eventuale icona custom per il marker
            var iconMarket = 'http://cdn1.buuteeq.com/aspx/shared/images/location/Balloon/1/A.png';

            //Creazione contenuto infoWindow (title del post e immagine)
            var content = '<div class="info-window">' +
                '<div class="title">' + name + '</div>' +
                '<img src="' + img + '" alt="' + name + '">'
            '</div>';

            //Creazione del marker per un punto di interesse
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lon),
                map: map,
                icon: iconMarket,
                title: name
            });

            //Inserisco il marker appena creato in un vettore da usare successivamente
            arrayMarker[index] = marker;

            //Listener che al click sul marker apre l'infoWindow
            marker.addListener('click', function () {
                infoWindow.setContent(content);
                infoWindow.open(map, marker);
            });

            if ($(this).find('a').hasClass('active')) {

                //Apertura dell'infoWindow rispetto al punto di interesse attivo
                infoWindow.setContent(content);
                infoWindow.open(map, marker);

                //Recupero l'indice della località
                var index = $(this).find('a').data("location-index");

                if (index > 0) {
                    //Cambio il nome del punto di interesse nella DOM
                    name = $(this).find('a').data("location-name");
                    $("#location-title").html(name);

                    //Visualizzo il contenuto testuale del punto di interesse nascondendo tutti gli altri (sono già stampati e resi invisibili)
                    $("#info .item").addClass('hide');
                    $("#info .item[data-index='" + index + "']").removeClass('hide');

                    //Imposto la select per generare il percorso con la partenza dalla località attiva
                    $("#directions select[name='from_direction']").prop("selectedIndex", index);
                }
            }

            //Evento al click dell'elenco puntato con i punti di interesse
            $('a', this).click(function (event) {

                //Setto la classe active sulla voce cliccata
                $(".locations-list li a").each(function () {
                    $(this).removeClass('active');
                });
                $(this).addClass('active');

                //Mi leggo l'indice della località
                var index = $(this).data("location-index");

                //Mi carico il relativo marker 
                currentMarker = arrayMarker[index];

                //Centro la mappa sul marker
                map.setCenter(currentMarker.getPosition());

                //Apro infoWindow sul marker corrente
                infoWindow.setContent(content);
                infoWindow.open(map, currentMarker);

                //Cambio il nome del punto di interesse nella DOM
                name = $(this).data("location-name");
                $("#location-title").html(name)

                //Visualizzo il contenuto testuale del punto di interesse nascondendo tutti gli altri (sono già stampati e resi invisibili)
                $("#info .item").addClass('hide');
                $("#info .item[data-index='" + index + "']").removeClass('hide');

                //Imposto la select per generare il percorso con la partenza dalla località selezionata
                $("#directions select[name='from_direction']").prop("selectedIndex", index);

                return false;
            });

        });


        //Gestione freccette di navigazione, controllo l'indice del menù delle località e eseguo il trigger del click sulla voce precedente o successiva
        $(".scrolling.prev").click(function (event) {
            var index = $(".locations-list li a.active").data("location-index");
            if (index == 0) {
                index = $(".locations-list li").length - 1;
            } else {
                index--;
            }
            $(".locations-list li a[data-location-index='" + index + "']").trigger("click");
        });

        $(".scrolling.next").click(function (event) {
            var index = $(".locations-list li a.active").data("location-index");
            if (index == ($(".locations-list li").length - 1)) {
                index = 0;
            } else {
                index++;
            }
            $(".locations-list li a[data-location-index='" + index + "']").trigger("click");
        });

        //Gestione del menù per selezionare il tipo di trasporto (Auto, Piedi, Bicicletta o Bus)
        $(".location-slideshow .mode_type").each(function () {
            $(this).click(function (event) {
                var index = $(this).data("index");
                $("#directions .mode_type").removeClass("selected");
                $(this).addClass("selected");
            });
        });

        //Form per stampare il percorso tra i due punti di interesse settati sulle select
        $(".location-slideshow .search-directions").click(function (event) {

            var travel = $(".location-slideshow .mode_type.selected").data("value")

            var from = $("#directions select[name='from_direction']").val().split(",");
            var to = $("#directions select[name='to_direction']").val().split(",");

            var request = {
                origin: new google.maps.LatLng(from[0], from[1]),
                destination: new google.maps.LatLng(to[0], to[1]),
                travelMode: google.maps.DirectionsTravelMode[travel]
            };

            directionsDisplay.setMap(map);
            directionsDisplay.setPanel(document.getElementById('map_route'));

            directionsService.route(request, function (response, status) {

                if (status == google.maps.DirectionsStatus.OK) {
                    directionsDisplay.setDirections(response);
                }

            });

        });

    }


    /**
     * Funzione per l'attivazione del menu responsive
     */

    function responsiveMenu() {
        $('.main-navigation').find('a[href="#"]').each(function () {
            $(this).click(function (event) {
                event.preventDefault();
            });
        });

        // if ($(window).width() <= viewportSize) { // se minore o uguale a 1199px di default
        var menuPrimaryOffcanvas = $("#js-menu-primary-offcanvas");
        var fixedMenu = $('#js-fixed-menu')[0];

        if (!fixedMenu) return;

        var stickyHeader = new Waypoint.Sticky({
            element: fixedMenu
        });

        $('.main-navigation').find('a[href="#"]').each(function () {
            $(this).click(function (event) {
                $('ul.sub-menu').not($(this).next()).removeClass('open');
                $(this).next().toggleClass('open');
            });
        });

        $("#js-menu-offcanvas-button-open").click(function () {
            menuPrimaryOffcanvas.addClass("offcanvas-open");
        });

        $("#js-menu-offcanvas-button-close").click(function () {
            menuPrimaryOffcanvas.removeClass("offcanvas-open");
        });
        // } else {
        //     var stickyHeader = new Waypoint.Sticky({
        //         element: $('#js-header')[0],
        //         // offset: -250 // l'offset è utile se non vuoi far partire subito fisso il menu
        //     });
        // }
    }


    /*
     *  Funzioni per PhotoSwiper
     */
    function addImageSizeForPhotoSwiper() {
        var thumbs = $('img[data-big-size]');
        thumbs.each(function (index) {
            if ($(this).parent('a').length > 0) {
                var isImageLink = $(this).parent('a').attr('href').match(/\.(jpeg|jpg|gif|png)$/);
                if (isImageLink) {
                    big_size = $(this).data('big-size');
                    link = $(this).parent('a');
                    link.attr('data-size', big_size);
                    link.wrap('<div class="single-image"></div>');
                }
            }
        });
    }

    function initPhotoSwiper(selector) {
        var galleryItems = $(selector);
        var pswpItems = [];
        // galleryItems.each(function(index) {
        //     var dimensions = $(this).find('a').data('size').split('x');
        //     var width = parseInt(dimensions[0], 10);
        //     var height = parseInt(dimensions[1], 10);

        //     myImage = {
        //         src: $(this).find('a').attr('href'),
        //         w: width,
        //         h: height,
        //         msrc: $(this).find('img').attr('src')
        //     };

        //     pswpItems.push(myImage);
        // });


        // galleryItems.each(function(index) {
        //     $(this).click(function(evt) {
        //         evt.preventDefault();
        //         openPhotoSwipe(pswpItems, index);
        //     });
        // });

        var originalItems = galleryItems.closest('.owl-item:not(.cloned)');

        if (originalItems.length == 0) {
            originalItems = galleryItems;
        }

        originalItems.each(function (index) {
            var dimensions = $(this).find('a').data('size').split('x');
            var width = parseInt(dimensions[0], 10);
            var height = parseInt(dimensions[1], 10);

            var myImage = {
                src: $(this).find('a').attr('href'),
                w: width,
                h: height,
                msrc: $(this).find('img').attr('src')
            };

            pswpItems.push(myImage);
        });

        originalItems.each(function (index) {
            $(this).click(function (evt) {
                evt.preventDefault();
                openPhotoSwipe(pswpItems, index);
            });
        });
    }

    function openPhotoSwipe(galleryItems, index) {
        var options = {
            index: index
        };
        var pswpElement = $('.pswp')[0];

        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, galleryItems, options);

        // Fix per il fullscreen in Chrome
        gallery.listen('initialZoomIn', function () {
            var fsButton = pswpElement.querySelector('.pswp__button--fs');

            if (fsButton) {
                // Intercetto il click PRIMA che PhotoSwipe lo gestisca
                fsButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();

                    var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement ||
                        document.mozFullScreenElement || document.msFullscreenElement;

                    if (!isFullscreen) {
                        // Entra in fullscreen
                        var requestFS = pswpElement.requestFullscreen ||
                            pswpElement.webkitRequestFullscreen ||
                            pswpElement.webkitRequestFullScreen ||
                            pswpElement.mozRequestFullScreen ||
                            pswpElement.msRequestFullscreen;

                        if (requestFS) {
                            requestFS.call(pswpElement);
                            // Forzo display block
                            setTimeout(function () {
                                $(pswpElement).css('display', 'block').addClass('pswp--fs');
                            }, 100);
                        }
                    } else {
                        // Esci dal fullscreen
                        var exitFS = document.exitFullscreen ||
                            document.webkitExitFullscreen ||
                            document.webkitCancelFullScreen ||
                            document.mozCancelFullScreen ||
                            document.msExitFullscreen;

                        if (exitFS) {
                            exitFS.call(document);
                            $(pswpElement).removeClass('pswp--fs');
                        }
                    }
                }, true); // Uso capture per intercettare prima degli altri handler
            }
        });

        // Listener per quando si entra/esce dal fullscreen
        var fullscreenChangeHandler = function () {
            var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement ||
                document.mozFullScreenElement || document.msFullscreenElement;

            if (isFullscreen === pswpElement) {
                // Siamo in fullscreen, forzo la visibilità
                $(pswpElement).css('display', 'block').addClass('pswp--fs');
            } else {
                $(pswpElement).removeClass('pswp--fs');
            }
        };

        // Aggiungo listener per tutti i vendor
        document.addEventListener('fullscreenchange', fullscreenChangeHandler);
        document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler);
        document.addEventListener('mozfullscreenchange', fullscreenChangeHandler);
        document.addEventListener('MSFullscreenChange', fullscreenChangeHandler);

        // Cleanup quando la galleria si chiude
        gallery.listen('close', function () {
            document.removeEventListener('fullscreenchange', fullscreenChangeHandler);
            document.removeEventListener('webkitfullscreenchange', fullscreenChangeHandler);
            document.removeEventListener('mozfullscreenchange', fullscreenChangeHandler);
            document.removeEventListener('MSFullscreenChange', fullscreenChangeHandler);
        });

        gallery.init();
    }


    function smoothScroll() {
        $("a[href*='#']").not("[href='#'],[data-toggle]").click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {

                    if (target.attr('data-paddingTopScroll')) {
                        var adjust = target.attr('data-paddingTopScroll');
                    }
                    else {
                        var adjust = target.css('padding-top') ? target.css('padding-top').replace('px', '') : 0;
                    }

                    $('html, body').animate({
                        scrollTop: target.offset().top - adjust
                    }, 1000);

                    return false;
                }
            }
        });
    }

    function startOwl(selector) {
        var DESIGN_WIDTH_DEFAULT = 1920; // puoi cambiarlo mettendo data-owl-design-width sull'elemento
        var RESIZE_DEBOUNCE_MS = 120;

        function calcResponsivePx(px, designWidth) {
            px = parseFloat(px) || 0;
            designWidth = parseFloat(designWidth) || DESIGN_WIDTH_DEFAULT;
            if (px === 0) return 0;
            // scala proporzionale: (px sul design) -> px sull'viewport corrente
            return Math.round(px / designWidth * window.innerWidth);
        }

        function initFunc(event) {
            var $carousel = $(event.target);
            var $stage = $carousel.find('.owl-stage');
            // Misuriamo solo gli item originali (non .cloned) e usiamo outerWidth(true)
            var $items = $carousel.find('.owl-item:not(.cloned)');
            var elW = 0;

            $items.each(function () {
                var $it = $(this);
                // outerWidth(true) include margin dx/sx (se presenti)
                var w = $it.outerWidth(true) || 0;
                elW += w;
            });

            // Se la larghezza calcolata è maggiore della stage attuale, forziamo la larghezza
            if (elW > 0 && elW > $stage.width()) {
                $stage.width(elW);
            }

            // Se immagini non ancora caricate, ricalcola quando finiscono il load
            var $imgs = $carousel.find('img');
            var imgsToLoad = $imgs.length;
            if (imgsToLoad > 0) {
                var recalc = function () {
                    var newW = 0;
                    $carousel.find('.owl-item:not(.cloned)').each(function () {
                        newW += $(this).outerWidth(true) || 0;
                    });
                    if (newW > 0 && newW > $stage.width()) {
                        $stage.width(newW);
                    }
                };

                $imgs.each(function () {
                    if (this.complete && this.naturalWidth !== 0) {
                        imgsToLoad--;
                    } else {
                        $(this).one('load error', function () {
                            imgsToLoad--;
                            if (imgsToLoad <= 0) {
                                recalc();
                                // forza anche il refresh di Owl per aggiornare stato interno
                                $carousel.trigger('refresh.owl.carousel');
                            }
                        });
                    }
                });

                // Fallback: anche se qualche evento load viene perso, ricalcola e fornisci refresh dopo 500ms
                setTimeout(function () { recalc(); $carousel.trigger('refresh.owl.carousel'); }, 500);
            }

            var $nav = $carousel.find('.owl-nav');

            // Gestione spostamento navigazione in elemento personalizzato
            var customNavTarget = $carousel.data('owl-nav-target');
            if (customNavTarget) {
                var $customContainer = $(customNavTarget);
                if ($customContainer.length > 0) {
                    // Sposta la navigazione nell'elemento personalizzato
                    $nav.detach().appendTo($customContainer);
                }
            }

            // if ($(window).width() > 1024 && !$carousel.hasClass('camera-gallery') && !$carousel.hasClass('page-gallery') && !$carousel.hasClass('header-carousel')) {
            if (!$carousel.hasClass('camera-gallery') && !$carousel.hasClass('page-gallery') && !$carousel.hasClass('header-carousel')) {
                if ($nav.find('.wrap').length === 0) { // evita doppio wrap
                    $nav.find('.owl-prev, .owl-next').wrapAll('<div class="wrap" />');
                }
            }
        }

        $(selector).each(function () {
            var $owl = $(this);

            // salva l'HTML dell'ultimo elemento originale (prima che Owl lo riorganizzi)
            try {
                var $origChildren = $owl.children();
                var lastOrig = $origChildren.last();
                if (lastOrig && lastOrig.length) {
                    $owl.data('__lastOriginalSlideHtml', lastOrig.prop('outerHTML'));
                }
            } catch (err) {
                $owl.data('__lastOriginalSlideHtml', '');
            }

            // prendi i valori "originali" (in px) dal markup
            var designWidth = $owl.data('owl-design-width') || DESIGN_WIDTH_DEFAULT;
            var stagePaddingPx = $owl.data('owl-stage-padding') || 0;
            var marginPx = $owl.data('owl-margin') || 0;

            // calcola i px effettivi da passare a Owl (scala sulla viewport)
            var stagePadding = calcResponsivePx(stagePaddingPx, designWidth);
            var margin = calcResponsivePx(marginPx, designWidth);

            // costruisci params (con valori calcolati)
            var params = {
                nav: $owl.data('owl-navigation'),
                navSpeed: Number($owl.data('owl-slide-speed')) || 250,
                autoplay: $owl.data('owl-autoplay'),
                autoplayTimeout: Number($owl.data('owl-autoplay-timeout')) || 5000,
                dots: $owl.data('owl-dots'),
                dotsSpeed: Number($owl.data('owl-dots-speed')) || 250,
                loop: $owl.data('owl-loop'),
                autoHeight: false,
                autoWidth: $owl.data('owl-auto-width'),
                smartSpeed: Number($owl.data('owl-smart-speed')) || 250,
                stagePadding: stagePadding,
                margin: margin,
                lazyLoad: true,
                rtl: $owl.data('owl-rtl'),
                slideBy: $owl.data('owl-slide-by') || 1,
                navText: [
                    '<i class="icon-edt-arrow-left-3"></i>',
                    '<i class="icon-edt-arrow-right-3"></i>'
                ],
                onInitialized: initFunc,
                onRefreshed: initFunc
            };

            if ($owl.data('owl-single-item')) {
                params.items = 1;
            } else {
                params.responsive = {
                    0: { items: Number($owl.data('owl-items-xs')) || 1 },
                    768: { items: Number($owl.data('owl-items-sm')) || 1 },
                    992: { items: Number($owl.data('owl-items-md')) || 1 },
                    1200: { items: Number($owl.data('owl-items-lg')) || 1 },
                    1440: { items: Number($owl.data('owl-items-xl')) || 1 }
                };
            }

            if ($owl.data('owl-custom-arrows')) {
                params.navText = [
                    '<span class="prev-icon"></span>',
                    '<span class="next-icon"></span>'
                ];
            }

            // inizializza l'owl con i valori calcolati (funzionerà subito)
            $owl.owlCarousel(params);

            // Fix per navigazione mobile: gestione manuale indice carousel quando loop: false
            var navigationLocked = false;
            var lockTimeout = null;
            var isDragging = false;
            var dragTimeout = null;
            var manualCurrentIndex = 0;
            var lastNavigationTime = 0;

            function lockNavigation() {
                navigationLocked = true;
                clearTimeout(lockTimeout);
                lockTimeout = setTimeout(function () {
                    navigationLocked = false;
                }, 150); // Ridotto da 400ms a 150ms per più reattività
            }

            // Traccia drag events per prevenire navigazione accidentale durante swipe
            $owl.on('drag.owl.carousel', function (event) {
                isDragging = true;
                // Timeout di sicurezza per resettare isDragging
                clearTimeout(dragTimeout);
                dragTimeout = setTimeout(function () {
                    isDragging = false;
                }, 400);
            });

            $owl.on('dragged.owl.carousel', function (event) {
                // Reset immediato dopo drag completato
                clearTimeout(dragTimeout);
                setTimeout(function () {
                    isDragging = false;
                }, 50); // Ridotto da 100ms a 50ms
            });

            // Usa translate invece di changed per tracciare l'indice (più affidabile e non blocca la navigazione)
            $owl.on('translate.owl.carousel', function (event) {
                // Traccia manualmente l'indice corrente
                if (event.item && typeof event.item.index !== 'undefined') {
                    var owlData = $owl.data('owl.carousel');
                    if (owlData) {
                        manualCurrentIndex = owlData.relative(event.item.index);
                    }
                }
            });

            // Sovrascrivi completamente il comportamento delle frecce native dopo l'inizializzazione
            setTimeout(function () {
                var owlData = $owl.data('owl.carousel');
                if (!owlData) return;

                var $prevBtn = $owl.find('.owl-nav .owl-prev');
                var $nextBtn = $owl.find('.owl-nav .owl-next');

                function handlePrev(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    // Non navigare se stiamo draggando
                    if (isDragging) {
                        console.log('Prev blocked: dragging');
                        return false;
                    }

                    // Previeni click troppo ravvicinati SOLO per eventi touch su mobile
                    var now = Date.now();
                    if (e.type === 'touchend' && (now - lastNavigationTime < 150)) {
                        console.log('Prev blocked: too soon after touch');
                        return false;
                    }

                    if (navigationLocked) {
                        console.log('Prev blocked: navigation locked');
                        return false;
                    }

                    // Usa l'indice tracciato manualmente come fallback affidabile
                    var current = manualCurrentIndex;

                    // Verifica con i metodi di Owl se disponibili
                    try {
                        var owlCurrent = owlData.relative(owlData.current());
                        if (owlCurrent >= 0) {
                            current = owlCurrent;
                        }
                    } catch (err) {
                        console.log('Owl prev index error:', err);
                    }

                    console.log('Prev clicked - current:', current, 'target:', current - 1);

                    if (current > 0) {
                        lockNavigation();
                        lastNavigationTime = now;
                        manualCurrentIndex = current - 1;
                        $owl.trigger('to.owl.carousel', [current - 1, 300, true]);
                    }
                    return false;
                }

                function handleNext(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    // Non navigare se stiamo draggando
                    if (isDragging) {
                        console.log('Next blocked: dragging');
                        return false;
                    }

                    // Previeni click troppo ravvicinati SOLO per eventi touch su mobile
                    var now = Date.now();
                    if (e.type === 'touchend' && (now - lastNavigationTime < 150)) {
                        console.log('Next blocked: too soon after touch');
                        return false;
                    }

                    if (navigationLocked) {
                        console.log('Next blocked: navigation locked');
                        return false;
                    }

                    // Usa l'indice tracciato manualmente come fallback affidabile
                    var current = manualCurrentIndex;
                    var total = owlData.items().length;

                    // Verifica con i metodi di Owl se disponibili
                    try {
                        var owlCurrent = owlData.relative(owlData.current());
                        if (owlCurrent >= 0) {
                            current = owlCurrent;
                        }
                    } catch (err) {
                        console.log('Owl next index error:', err);
                    }

                    console.log('Next clicked - current:', current, 'target:', current + 1, 'total:', total);

                    if (current < total - 1) {
                        lockNavigation();
                        lastNavigationTime = now;
                        manualCurrentIndex = current + 1;
                        $owl.trigger('to.owl.carousel', [current + 1, 300, true]);
                    }
                    return false;
                }

                // Rimuovi tutti gli eventi esistenti e aggiungi i nostri
                $prevBtn.off().on('click touchend', handlePrev);
                $nextBtn.off().on('click touchend', handleNext);
            }, 100);

            // se richiesto, aggiungi slide extra invisibili per permettere navigazione aggiuntiva
            var addSlideFlag = $owl.data('owl-add-slide');
            if (addSlideFlag === true || addSlideFlag === 'true') {
                // evita doppia aggiunta
                if (!$owl.data('__addedExtraSlide')) {
                    try {
                        // Determina il numero di elementi visibili basato sulla larghezza corrente
                        var windowWidth = $(window).width();
                        var visibleItems = 1; // default

                        if (!$owl.data('owl-single-item')) {
                            if (windowWidth >= 1440) {
                                visibleItems = Number($owl.data('owl-items-xl')) || 1;
                            } else if (windowWidth >= 1200) {
                                visibleItems = Number($owl.data('owl-items-lg')) || 1;
                            } else if (windowWidth >= 992) {
                                visibleItems = Number($owl.data('owl-items-md')) || 1;
                            } else if (windowWidth >= 768) {
                                visibleItems = Number($owl.data('owl-items-sm')) || 1;
                            } else {
                                visibleItems = Number($owl.data('owl-items-xs')) || 1;
                            }
                        }

                        // Conta il numero di slide effettivamente pubblicate (escluse quelle clonate)
                        var actualSlides = $owl.find('.owl-item:not(.cloned)').length;
                        if (actualSlides === 0) {
                            // Se non ci sono ancora items (prima dell'inizializzazione), conta i figli diretti
                            actualSlides = $owl.children().length;
                        }

                        // Determina quante slide invisibili aggiungere
                        var slidesToAdd = 1; // default: una slide
                        if (visibleItems === actualSlides) {
                            slidesToAdd = 2; // se elementi visibili = elementi pubblicati, aggiungi due slide
                        }

                        // Crea slide invisibili con contenuto minimo
                        var placeholderHtml = '<div class="owl-placeholder-slide" style="opacity: 0; pointer-events: none; width: 1px; min-height: 1px;"><div style="width: 1px; height: 1px;"></div></div>';

                        var data = $owl.data('owl.carousel');
                        if (data && typeof data.add === 'function') {
                            // Aggiungi le slide invisibili
                            for (var i = 0; i < slidesToAdd; i++) {
                                $owl.trigger('add.owl.carousel', [placeholderHtml]);
                            }
                            $owl.trigger('refresh.owl.carousel');
                            $owl.data('__addedExtraSlide', true);
                            $owl.data('__addedSlidesCount', slidesToAdd);

                            // Forza l'aggiornamento delle impostazioni per abilitare la navigazione
                            setTimeout(function () {
                                var owlData = $owl.data('owl.carousel');
                                if (owlData) {
                                    // Forza owl a riconoscere che ci sono slide navigabili
                                    owlData._items = $owl.find('.owl-item');
                                    owlData.update();
                                }
                            }, 100);
                        } else {
                            // fallback: append placeholder direttamente e refresh
                            for (var i = 0; i < slidesToAdd; i++) {
                                $owl.append(placeholderHtml);
                            }
                            $owl.trigger('refresh.owl.carousel');
                            $owl.data('__addedExtraSlide', true);
                            $owl.data('__addedSlidesCount', slidesToAdd);
                        }
                    } catch (err) {
                        console.log('Failed to add extra placeholder slides:', err);
                    }
                }
            }

            // salva i px "origine" per ri-calcolare al resize
            $owl.data('__stagePaddingPx', stagePaddingPx);
            $owl.data('__marginPx', marginPx);
            $owl.data('__designWidth', designWidth);

            // Forza l'abilitazione della navigazione se è stata aggiunta una slide extra
            if (addSlideFlag === true || addSlideFlag === 'true') {
                setTimeout(function () {
                    var $navButtons = $owl.find('.owl-nav button');
                    $navButtons.removeClass('disabled').prop('disabled', false);

                    // Override del controllo interno di Owl per forzare la navigazione
                    var owlData = $owl.data('owl.carousel');
                    if (owlData && owlData.settings) {
                        // Forza owl a pensare che ci siano più slide navigabili
                        var originalUpdate = owlData.update;
                        owlData.update = function () {
                            originalUpdate.call(this);
                            // Re-abilita navigazione dopo ogni update
                            var $nav = $owl.find('.owl-nav button');
                            $nav.removeClass('disabled').prop('disabled', false);
                        };
                    }
                }, 200);
            }

            // custom prev/next
            var navClickTimer = null;
            var isNavigating = false;

            if ($owl.data('owl-prev')) {
                $($owl.data('owl-prev')).off('click.owl touchend.owl').on('click.owl touchend.owl', function (e) {
                    e.preventDefault();
                    if (isNavigating) return false;
                    isNavigating = true;
                    $owl.trigger('prev.owl.carousel');
                    clearTimeout(navClickTimer);
                    navClickTimer = setTimeout(function () {
                        isNavigating = false;
                    }, 350);
                    return false;
                });
            }
            if ($owl.data('owl-next')) {
                $($owl.data('owl-next')).off('click.owl touchend.owl').on('click.owl touchend.owl', function (e) {
                    e.preventDefault();
                    if (isNavigating) return false;
                    isNavigating = true;
                    $owl.trigger('next.owl.carousel');
                    clearTimeout(navClickTimer);
                    navClickTimer = setTimeout(function () {
                        isNavigating = false;
                    }, 350);
                    return false;
                });
            }

            // aggiorna opzioni al resize (debounced)
            var resizeTimer = null;
            var lastWindowWidth = $(window).width();
            var isTransitioning = false;

            // Track transitions to avoid refresh during navigation
            $owl.on('translate.owl.carousel', function () {
                isTransitioning = true;
            });
            $owl.on('translated.owl.carousel', function () {
                setTimeout(function () {
                    isTransitioning = false;
                }, 50);
            });

            $(window).on('resize.' + ($owl.attr('id') || Math.random()), function () {
                clearTimeout(resizeTimer);
                var currentWindowWidth = $(window).width();

                // Only process resize if width actually changed (avoid mobile address bar hide/show)
                if (Math.abs(currentWindowWidth - lastWindowWidth) < 5) {
                    return;
                }

                resizeTimer = setTimeout(function () {
                    // Don't refresh during transitions
                    if (isTransitioning) return;

                    var data = $owl.data('owl.carousel');
                    if (!data) return;
                    var padPx = $owl.data('__stagePaddingPx') || 0;
                    var marPx = $owl.data('__marginPx') || 0;
                    var design = $owl.data('__designWidth') || DESIGN_WIDTH_DEFAULT;
                    data.options.stagePadding = calcResponsivePx(padPx, design);
                    data.options.margin = calcResponsivePx(marPx, design);
                    $owl.trigger('refresh.owl.carousel');
                    lastWindowWidth = $(window).width();
                }, RESIZE_DEBOUNCE_MS);
            });

        });
    }

    /*****************************************************************************************/

    function toConsole(string) {
        if ((typeof window.console == "undefined")) {
            alert(string);
        } else console.log(string);
    }

    function $j(argument) {
        var result = jQuery(argument);
        if (result.length === 0) return null;
        else return result;
    }

    function translateCountdown(langCountdown) {

        countdown.resetLabels();

        if (langCountdown == 'it') {
            countdown.setLabels(
                ' millisecondo| secondo| minuto| ora| giorno| settimana| mese| anno| decade| secolo| millennio',
                ' millisecondi| secondi| minuti| ore| giorni| settimane| mesi| anni| decadi| secoli| millenni',
                ' e ',
                ' '
            );
        } else if (langCountdown == 'de') {
            countdown.setLabels(
                ' Millisekunde| zweite| Minute| jetzt| Tag| Woche| Monat| Jahr| Jahrzehnt| Jahrhundert| Jahrtausend',
                ' Millisekunden| Sekunden| Minuten| Stunden| Tage| Wochen| Monate| Alter| Jahrzehnte| Jahrhunderte| Jahrtausende',
                ' und ',
                ' '
            );
        } else if (langCountdown == 'fr') {
            countdown.setLabels(
                ' milliseconde| deuxième| minute| maintenant| jour| semaine| mois| année| décennie| siècle| millénaire',
                ' millisecondes| secondes| minutes| heures| journées| semaines| mois| âge| décennies| siècles| millénaires',
                ' et ',
                ' '
            );
        }

    }

    function edtCountdown() {

        jQuery(".edt_countdown_class").find('.item').each(function () {

            var dataInizio = "";
            var questo = jQuery(this);
            jQuery.post(
                url.ajax_url,
                {
                    'action': 'edita_ajax_get_start_countdown_date',
                    'offerId': questo.data('offerid'),
                },

                function (response) {
                    setInterval(function () {
                        stampaCountdown(questo, response);
                    }, 3600);
                }
            );
        });
    }

    function stampaCountdown(item, response) {

        jQuery(item).find('.pageTimer').empty().append(
            moment().countdown(response, countdown.DAYS | countdown.HOURS).toString()
        );
    }

    function closePhotoswipe() {

        $('.pswp__button--close').click(function () {
            if ($('.pswp').hasClass('pswp--open')) {
                $('.pswp').removeClass('pswp--supports-fs pswp--open pswp--notouch pswp--css_animation pswp--svg pswp--animated-in pswp--visible pswp--zoom-allowed pswp--has_mouse');
            }
        });

        $(window).scroll(function () {
            if ($('.pswp').hasClass('pswp--open')) {
                $('.pswp').removeClass('pswp--supports-fs pswp--open pswp--notouch pswp--css_animation pswp--svg pswp--animated-in pswp--visible pswp--zoom-allowed pswp--has_mouse');
            }
        });
    }

    /*
     * Funzione per utilizzare MixItUp da select
     */

    function filterElements() {

        var containers = [
            {
                selectFilter: '.select-filters',
                selector: '.mix-filter-support',
                activator: '',
                initialFilter: 'all',
                scope: 'global'
            },
            {
                selectFilter: '.select-filters-vacanza',
                selector: '.vacanza-container',
                activator: '.first-filter-vacanza',
                initialFilter: '',
                scope: 'local'
            },
            {
                selectFilter: '.select-filters-offerte-esperienze',
                selector: '.offerte-esperienze-container',
                activator: '.first-filter-offerte-esperienze',
                initialFilter: '',
                scope: 'local'
            },
        ];

        containers.forEach(function (container) {

            if ($(container.selector).length) {

                var initialFilter = container.initialFilter;

                if ($(container.activator).length) {
                    $(container.activator).each(function () {
                        var firstFilter = $(this).children(':first-child').attr('class').split(' ')[0];
                        initialFilter = '.' + firstFilter;
                    });
                }

                if (initialFilter === '' && $(container.selector).data('initial-filter')) {
                    initialFilter = '.' + $(container.selector).data('initial-filter');
                }

                var config = {
                    selectors: {
                        control: '[data-mixitup-control]'
                    },
                    load: {
                        filter: initialFilter
                    },
                    controls: {
                        scope: container.scope
                    }
                };

                var mixer = mixitup(container.selector, config);

                $(container.selectFilter).on('change', function () {
                    console.log('change!');
                    mixer.filter(this.value);
                });

            }

        });

        $('.item-filter button').each(function () {
            $(this).on('click', function () {
                if (!$(this).hasClass('active')) {
                    $(this).parent().find('.filter.active').removeClass('active');
                }
            });
        });

    }

    /**
     * Questo oggetto ci serve a verificare il dispositivo utilizzato dall'utente,
     * la i. nell'espressione regolare sta ad indicare una ricerca case-insensitive,
     * il metodo nativo test() serve a verificare la presenza della parola nell'espressione regolare,
     * ritorna un boleano.
     */
    var mapsMobileUrl = {
        isAndroid: function () {
            return /(android)/i.test(navigator.userAgent);
        },
        isIos: function () {
            return /(iPhone|iPad|iPod)/i.test(navigator.userAgent);
        }
    };


    function injectorLinkMaps() {
        var buttonMaps = $('#js-fixed-menu').find('.navigator');

        if (mapsMobileUrl.isAndroid()) buttonMaps.attr('href', phpMapsMobileUrl.android);

        if (mapsMobileUrl.isIos()) buttonMaps.attr('href', phpMapsMobileUrl.ios);

        if (!mapsMobileUrl.isAndroid() && !mapsMobileUrl.isIos()) buttonMaps.hide();
    }


    function slideMobile() {
        if (!$('body').hasClass('is-mobile')) return;

        var itemcount = 1;

        if (typeof mobileSize !== 'undefined') {

            $.each(mobileSize, function (index, item) {

                if ($(window).width() > 767) {
                    console.log(item);

                    $('.header-slideshow .itemcounter-' + itemcount + ' ' + 'img').attr({
                        src: item[0]['tablet'][0],
                        width: item[0]['tablet'][1],
                        height: item[0]['tablet'][2],
                    });
                } else {
                    $('.header-slideshow .itemcounter-' + itemcount + ' ' + 'img').attr({
                        src: item[0]['mobile'][0],
                        width: item[0]['mobile'][1],
                        height: item[0]['mobile'][2],
                    });
                }

                itemcount++;
            });
        }
    }


    function getUrlVars() {

        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    function accordion() {
        var accItem = document.getElementsByClassName("accordionItem");
        var accHD = document.getElementsByClassName("accordionItemHeading");

        if (accItem.length == 0) return;

        for (i = 0; i < accHD.length; i++) {
            accHD[i].addEventListener("click", toggleItem, false);
        }

        function toggleItem() {
            var itemClass = this.parentNode.className;
            for (i = 0; i < accItem.length; i++) {
                accItem[i].className = "accordionItem closeItem";
            }
            if (itemClass == "accordionItem closeItem") {
                this.parentNode.className = "accordionItem openItem";
            }

            var headerHeight = $('#js-header').outerHeight() + 50;

            $('html, body').animate({
                scrollTop: $(this).offset().top - headerHeight,
            }, 400);
        }
    }

    function getCookie(name) {

        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    }

    function setCookie(name, value, days) {

        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    function initVacanzaInteraction() {
        $('.vacanza-title').hover(function () {
            var index = $(this).data('index');
            var $activeImage = $('.vacanza-image[data-index="' + index + '"]');
            var newLink = $activeImage.data('link');

            // Rimuovi la classe active da tutti gli elementi
            $('.vacanza-image, .vacanza-title').removeClass('active');

            // Aggiungi la classe active agli elementi corrispondenti
            $activeImage.addClass('active');
            $(this).addClass('active');

            // Aggiorna il link dell'immagine attiva
            var $imageLink = $('.vacanza-images .vacanza-image-link');
            if (newLink && newLink !== 'null' && newLink !== '') {
                $imageLink.attr('href', newLink).removeClass('disabled');
            } else {
                $imageLink.addClass('disabled').removeAttr('href');
            }
        });
    }

    function addNumSlides(owl, rewind, arrowContainer) {

        if (typeof rewind === "undefined") {
            rewind = true;
        }

        if (typeof arrowContainer === "undefined") {
            var prevNav = owl.find('.owl-prev');
            var nextNav = owl.find('.owl-next');
        } else {
            var prevNav = arrowContainer.find('.owl-prev');
            var nextNav = arrowContainer.find('.owl-next');
        }

        var numSlides = $('<div>').addClass('numSlides');
        var autoplayTimeout = owl.attr('data-owl-autoplay-timeout');
        var loop = owl.attr('data-owl-loop');
        var isDragEvent;

        if (!autoplayTimeout || autoplayTimeout == "false") {
            autoplayTimeout = 2000;
        }

        numSlides.insertAfter(prevNav);
        numSlides.insertBefore(nextNav);

        updateNumSlides();

        if (loop == "true") {
            owl.on('drag.owl.carousel', function (event) {
                isDragEvent = true;
            });

            owl.on('changed.owl.carousel resized.owl.carousel', function (event) {
                var slideValue;
                var currentSlideIndex = event.item.index;
                var allSlideElements = $(event.target).find('.owl-item');
                var currentSlideElement = allSlideElements.eq(currentSlideIndex);
                var otherSlideElements = allSlideElements.not(currentSlideElement);
                var clonedElements = currentSlideElement.prevAll('.owl-item.cloned');
                var currentIndex = event.item.index - clonedElements.length;

                if (currentSlideElement.hasClass('cloned')) {
                    slideValue = currentIndex;
                }
                else {
                    slideValue = currentIndex + 1;
                }

                if (slideValue == 0) {
                    slideValue = event.item.count;
                }

                updateNumSlides(slideValue);
            });

            owl.on('resized.owl.carousel', function (event) {
                updateNumSlides(event.item.index + 1);
            });
        }
        else {
            owl.on('changed.owl.carousel resized.owl.carousel', function (event) {

                var carouselData = owl.data('owl.carousel');
                var itemsPerSlide = carouselData.options.items || 1;
                var slideBy = carouselData.options.slideBy;

                // console.log(Math.ceil(event.item.index / itemsPerSlide) + 1)

                if (slideBy === 'page') {
                    var slideValue = Math.ceil(event.item.index / itemsPerSlide) + 1;
                    updateNumSlides(slideValue);
                }
                else {
                    var slideValue = event.item.index + 1;

                    if ($(window).width() > 1024 && event.item.index + 1 == event.item.count && rewind == true) {
                        // riparti dall'inizio del carousel
                        setTimeout(function () {
                            owl.trigger('to.owl.carousel', [0, 500, true]);
                        }, autoplayTimeout);
                    }

                    updateNumSlides(slideValue);    // var slideValue = event.property.value + 1;

                }
            });
        }

        // function updateNumSlides(cur) {
        //     if (typeof cur === "undefined") {
        //         cur = 1;
        //     }

        //     if(loop == "true") {
        //         var totalSlides = owl.find('.owl-item:not(.cloned)').length;
        //     }
        //     else {
        //         var totalSlides = owl.find('.owl-item').length;
        //     }

        //     var currentSlide = cur;
        //     numSlides.html('<span class="current">' + currentSlide + '</span>' + '<span class="total">' + totalSlides + '</span>');     
        // }

        function updateNumSlides(cur) {

            var carouselData = owl.data('owl.carousel');
            var itemsPerSlide = carouselData.settings.items || 1;
            var slideBy = carouselData.options.slideBy;

            // If the carousel has data-owl-slide="true" we consider that
            // there is an extra placeholder slide appended and we want
            // to ignore it in the visual total. Detect that here.
            var ignorePlaceholder = (owl.attr('data-owl-add-slide') === 'true');

            if (slideBy === 'page') {
                if (typeof cur === "undefined") {
                    cur = 1; // Owl Carousel usa base 0
                }

                var totalItems = owl.find('.owl-item:not(.cloned)').length;

                if (loop === "true") {
                    totalItems = owl.find('.owl-item:not(.cloned)').length;
                } else {
                    totalItems = owl.find('.owl-item').length;
                }

                // If requested, subtract the placeholder slide from the total
                if (ignorePlaceholder) {
                    totalItems = Math.max(0, totalItems - 1);
                }

                var totalSlides;
                var currentSlide;

                totalSlides = Math.ceil(totalItems / itemsPerSlide);
                currentSlide = cur;

                numSlides.html('<span class="current">' + currentSlide + '</span><span class="total">' + totalSlides + '</span>');
            }
            else {

                if (typeof cur === "undefined") {
                    cur = 1;
                }

                var totalItems = owl.find('.owl-item:not(.cloned)').length;

                if (loop == "true") {
                    totalItems = owl.find('.owl-item:not(.cloned)').length;
                } else {
                    totalItems = owl.find('.owl-item').length;
                }

                // If requested, subtract the placeholder slide from the total
                if (ignorePlaceholder) {
                    totalItems = Math.max(0, totalItems - 1);
                }

                var totalSlides = totalItems;
                var currentSlide = cur;

                numSlides.html('<span class="current">' + currentSlide + '</span>' + '<span class="total">' + totalSlides + '</span>');
            }
        }
    }

    $j(document).ready(function () {
        allClick();
        responsiveTable();
        addImageSizeForPhotoSwiper();
        iframeModalOpen();
        responsiveMenu();
        filterElements();
        injectorLinkMaps();
        slideMobile();
        // leggiTutto();
        accordion();
        initVacanzaInteraction();

        // Gestione classe scroll su .main-menu-bg se #main-menu ha scrollbar verticale (dinamico)
        function checkMainMenuScrollbar() {
            var $mainMenu = $('#main-menu');
            var $bg = $('.main-menu-bg');
            if ($mainMenu.length && $bg.length) {
                var hasScroll = $mainMenu[0].scrollHeight > $mainMenu[0].clientHeight;
                $bg.toggleClass('scroll', hasScroll);
            }
        }
        checkMainMenuScrollbar();
        $(window).on('resize', checkMainMenuScrollbar);

        // MutationObserver per intercettare cambiamenti dinamici
        var mainMenuEl = document.getElementById('main-menu');
        if (mainMenuEl) {
            var observer = new MutationObserver(function () {
                checkMainMenuScrollbar();
            });
            observer.observe(mainMenuEl, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true
            });
        }

        $('.feedback-description').expander({
            slicePoint: 300,
            sliceOn: '</p>',
            expandText: '[ + ]',
            userCollapseText: '[ - ]'
        });


        // if($('body').hasClass('home')) {
        //     $('div.entry-content').expander({
        //         slicePoint: 900,
        //         preserveWords: true,
        //         sliceOn: '</p>',
        //         expandText: url.expandText,
        //         userCollapseText: url.userCollapseText,
        //         expandPrefix: '',
        //     });
        // }


        // $('.feedback-description').collapser({
        // 	mode: 'chars',
        // 	truncate: 360,
        // 	showText: '[ + ]',
        // 	hideText: '[ - ]',
        // 	controlBtn: 'opener',
        // });

        startOwl('.owl-carousel');
        smoothScroll();

        if ($('.header-slideshow .owl-carousel').length > 0) {
            addNumSlides($('.header-slideshow .owl-carousel'));
        }

        if ($('#page-gallery .owl-carousel').length > 0) {
            addNumSlides($('#page-gallery .owl-carousel'), false, $('#page-gallery .custom-gallery-nav'));
        }

        closePhotoswipe();

        if (typeof lang && lang != 'en') {
            translateCountdown(lang);
        }

        edtCountdown();

        $('.gform_wrapper form').each(function () {

            $(this).checkEditaForm();
        });


        $('.checkNewsletter').each(function () {
            $(this).checkEditaForm();
        });

        $('.header-menu-inner').click(function () {

            var menuToggle = $(this).find($('#menu-toggle'));

            menuToggle.toggleClass('open');
            $('body').toggleClass('menu-opened');
            $('#js-header').toggleClass('menu-opened');

            if (menuToggle.hasClass('open')) {

                $('#main-menu').fadeIn('fast');

            } else {

                $('#main-menu').fadeOut('fast');
            }
        });

        // match heights

        $('.offer-inner a').matchHeight();
        $('.offer-description').matchHeight();
        $('.offer-price').matchHeight();


        // select camere / offerta in form

        if ($('#efb-form-21').length > 0) {

            var tipologia = getUrlVars()['tipo'];

            if (tipologia) {

                if (tipologia === 'offer') {

                    type_it = 'Offerta';

                    var nome = getUrlVars()['nome'];

                    $('.offer-hidden-input').val(type_it + ' - ' + nome.split('+').join(' '));
                }
                else if (tipologia === 'room') {

                    try {
                        var roomRaw = getUrlVars()['valore'] || '';
                        // replace + with space (common in querystrings), then decode %xx sequences
                        var room = decodeURIComponent(roomRaw.replace(/\+/g, ' '));
                        // replace dashes with spaces, collapse multiple spaces and trim
                        room = room.replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
                    } catch (e) {
                        var room = (getUrlVars()['valore'] || '').split('-').join(' ');
                    }

                    $('.room-hidden-input').val(room).focus();
                }
            }
        }

        $('.services-link').each(function () {
            $(this).on('click', function () {
                var popup = $(this).closest('.camera-text').find('.services-popup');
                var container = $(this).closest('article');
                popup.addClass('open');
                container.addClass('open');

                if ($('body').is('.is-mobile')) {
                    $('body').addClass('open-popup');
                }
            });
        });

        $('.close-popup').each(function () {
            $(this).on('click', function () {
                var popup = $(this).parent();
                var container = $(this).closest('article');
                popup.removeClass('open');
                container.removeClass('open');

                if ($('body').is('.is-mobile')) {
                    $('body').removeClass('open-popup');
                }
            });
        });

        if ($('body').hasClass('page-template-template-richiesta-preventivo')) {
            var urlParams = new URLSearchParams(window.location.search);

            if (urlParams.get('nome')) {
                var roomName = urlParams.get('nome');
                // Append the message after the first h1 on the page instead of setting #efb-432
                var message = url.roomQuoteMessage + ' ' + roomName;
                var $firstH1 = $('h1').first();
                if ($firstH1.length) {
                    $firstH1.after('<h2 class="room-quote-message">' + message + '</h2>');
                } else {
                    // Fallback to original behaviour if no h1 found
                    $('#efb-432').val(message);
                }

                // Seleziona l'opzione corrispondente nella select #efb-512
                var $select = $('#efb-512');
                if ($select.length) {
                    var optionFound = false;
                    $select.find('option').each(function () {
                        if ($(this).val() === roomName || $(this).text() === roomName) {
                            $(this).prop('selected', true);
                            $select.val($(this).val()).trigger('change');
                            optionFound = true;
                            return false; // break del loop
                        }
                    });
                }
            }
        }

        /* Fix per modale con contenuto dinamico */

        $('#feedModal').on('hidden.bs.modal', function (e) {
            $(this).removeData('bs.modal');
            $(".modal-content", this).empty();
        });
    });


    $j(window).load(function () {
        // $('.owl-carousel').trigger('refresh.owl.carousel');

        /*
         *	Attraverso il Google Loader carico il modulo mappa
         */
        if ($('body').hasClass('page-template-template-mappa')) {

            $.getScript('https://www.google.com/jsapi', function () {
                if (url.key) {
                    var map_params = 'language=' + url.lingua + '&key=' + url.key;
                }
                else {
                    var map_params = 'language=' + url.lingua;
                }

                google.load('maps', '3', {
                    other_params: map_params + '&libraries=places',
                    callback: function () {
                        initializeGmap();
                    }
                });
            });
        }

        var gallery = $('.gallery');

        if (gallery.length) {
            gallery.each(function (index) {
                if ($(this).hasClass('page-gallery')) {
                    initPhotoSwiper(".page-gallery .gallery-item")
                }
                else {
                    initPhotoSwiper("#" + $(this).attr('id') + " .gallery-icon");
                }
            });
        }

        initPhotoSwiper(".entry-content .single-image");
        // initPhotoSwiper(".entry-content .gallery-icon");

        $('.section-form .form-group').equalHeights();

        if ($(window).width() > 1024) {
            $('article.rooms-block.rooms .title').equalHeights();
            $('article.rooms-block.rooms .desc').equalHeights();
            $('.feedback-box').equalHeights();
        }

        if ($(window).width() > 767) {
            $('.servizi-slideshow .box-title .title').equalHeights();
            $('.servizi-slideshow .box-title .desc').equalHeights();
            $('.offer-block .title').equalHeights();
            $('.offer-block .offer-inner .price-box').equalHeights();
        }

        $.getScript('https://www.google.com/jsapi', function () {
            google.load('maps', '3', {
                other_params: 'language=it&key=' + url.key,
                callback: function () {
                    initializeGmap();
                    if ($("body").hasClass("page-template-template-locations")) {

                        initializeMap();

                        $(".owl-scrolling-container .prev").click(function () {
                            var index = $(".locations-list li").find("a.active").attr("data-location-index");
                            if (index == 0) {
                                index = $(".locations-list li").length - 1;
                            } else {
                                index--;
                            }
                            console.log(index)
                            $(".locations-list li").find("[data-location-index='" + index + "']").trigger('click');
                            //$(".location-slideshow .owl-carousel").trigger('owl.goTo', index);
                        });
                        $(".owl-scrolling-container .next").click(function () {
                            var index = $(".locations-list li").find("a.active").attr("data-location-index");
                            if (index == ($(".locations-list li").length - 1)) {
                                index = 0;
                            } else {
                                index++;
                            }
                            console.log(index)
                            $(".locations-list li").find("[data-location-index='" + index + "']").trigger('click');
                            //$(".location-slideshow .owl-carousel").trigger('owl.goTo', index);
                        });
                    }
                }
            });
        });
    });

    $j(window).scroll(function () {
        if ($(this).scrollTop() > 0) {
            $('#js-header').addClass('scroll');
            $('.main-menu-inner > img').hide();
        } else {
            $('#js-header').removeClass('scroll');
            $('.main-menu-inner > img').show();
        }
    });

    $j(window).resize(function () {



    });

})(jQuery);
